"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _HBField = require("./HBField.styles");
var _shared = require("../../utils/shared.utils");
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var HBField = function HBField(_ref) {
  var id = _ref.id,
    testIdName = _ref.testIdName,
    testId = _ref.testId,
    label = _ref.label,
    children = _ref.children,
    _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? false : _ref$inline,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top' : _ref$placement,
    _ref$isRequired = _ref.isRequired,
    isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'lg' : _ref$size,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$fontWeight = _ref.fontWeight,
    fontWeight = _ref$fontWeight === void 0 ? 'normal' : _ref$fontWeight,
    _ref$marginRight = _ref.marginRight,
    marginRight = _ref$marginRight === void 0 ? '8px' : _ref$marginRight,
    _ref$marginBottom = _ref.marginBottom,
    marginBottom = _ref$marginBottom === void 0 ? '8px' : _ref$marginBottom,
    _ref$marginLeft = _ref.marginLeft,
    marginLeft = _ref$marginLeft === void 0 ? '8px' : _ref$marginLeft,
    _ref$marginTop = _ref.marginTop,
    marginTop = _ref$marginTop === void 0 ? '0px' : _ref$marginTop,
    className = _ref.className,
    width = _ref.width,
    color = _ref.color,
    _ref$withIcon = _ref.withIcon,
    withIcon = _ref$withIcon === void 0 ? false : _ref$withIcon,
    preLabelContent = _ref.preLabelContent,
    postLabelContent = _ref.postLabelContent;
  var spacing = {
    marginTop: marginTop,
    marginRight: marginRight,
    marginBottom: marginBottom,
    marginLeft: marginLeft
  };
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName || id,
    suffix: 'field',
    componentName: 'HBField'
  });
  var contentWrapper = function contentWrapper() {
    var labelComponent = label && /*#__PURE__*/_react["default"].createElement(_HBField.StyledLabel, {
      id: id,
      text: label,
      withIcon: withIcon,
      size: size,
      inline: inline,
      placement: placement,
      disabled: disabled,
      fontWeight: fontWeight,
      isRequired: isRequired,
      spacing: spacing,
      width: width,
      color: color
    });
    if (preLabelContent || postLabelContent) {
      return /*#__PURE__*/_react["default"].createElement(_HBField.Wrapper, null, preLabelContent, labelComponent, postLabelContent);
    }
    return labelComponent;
  };
  return /*#__PURE__*/_react["default"].createElement(_HBField.Container, {
    inline: inline,
    placement: placement,
    className: className,
    onPaste: _shared.stopEventPropagation,
    "data-testid": finalTestId
  }, contentWrapper(), children);
};
var _default = exports["default"] = HBField;
//# sourceMappingURL=HBField.js.map